<template>
  <div class="test">
    <div class="fox">
      <button class="connect" @click="connectFox">连接小狐狸</button>
      <button class="connect" @click="connectWC">连接WalletConnect</button>
      <button class="connect" @click="connectLedger">连接Ledger</button>
      <button class="connect" @click="connectTrezor">连接Trezor</button>
      <div class="address">Address: {{ foxAddress }}</div>
      <div class="chainId">ChainId: {{ foxChainId }}</div>
      <div class="balance">ETH: {{ foxBalance }}</div>
      <button @click="disconnect">断开钱包</button>
      <button @click="getQuote">Quote</button>
      <button @click="getBalanceBySelf">一次获取全部</button>
      <button @click="getDecimals">获取精度</button>
      <ul class="list">
        <li class="item" v-for="item of ledgerAddress" :key="item.address">
          {{ item.address }}
        </li>
      </ul>
      <div class="token">
        <div class="token-item" v-for="item of showList" :key="item.address">
          {{ item.symbol }}: {{ item.balance }}
        </div>
      </div>
      <div class="line"></div>
      <div><button @click="getExchangeData">获取数据</button></div>
      <div>NPXS: {{ npxsBalance }}</div>
      <div>XS: {{ xsBalance }}</div>
      <div>rate: {{ npxsRate }}</div>
      <div><button @click="exchangeNPXS">兑换100NPXS</button></div>
    </div>
  </div>
</template>

<script>
import { MetaMask, WalletConnect, Ledger, Trezor } from '@/connect'
import http from '@/http/api'
import { ethers } from 'ethers'
import BN from 'bignumber.js'
import { GasNow } from '@/http/ws'
// import localeAbi from '@/connect/abi/index.js'

// const abi = localeAbi[process.env.VUE_APP_CHAIN]

export default {
  name: 'test',
  data() {
    return {
      foxAddress: '',
      foxChainId: '',
      wallet: null,
      wallet2: null,
      foxBalance: '',
      showList: [],
      npxsBalance: '',
      xsBalance: '',
      npxsRate: '',
      ledgerAddress: []
    }
  },
  methods: {
    connectFox() {
      this.wallet = new MetaMask()
      this.wallet
        .connect(event => {
          console.log('event', event)
        })
        .then(async () => {
          console.log('this.wallet', this.wallet.account)
          this.foxAddress = this.wallet.account
          this.foxChainId = this.wallet.chainId
          const balance = await this.wallet.getBalance()
          this.foxBalance = ethers.utils.formatUnits(balance)
          const gasNow = new GasNow()
          const gasPrice = await gasNow.getGasPrice()
          console.log('gasPrice', gasPrice)
          setTimeout(async () => {
            const gasPrice = await gasNow.getGasPrice()
            console.log('gasPrice', gasPrice)
          }, 9000)
        })
        .catch(() => {})
    },
    connectWC() {
      this.wallet = new WalletConnect()
      this.wallet
        .connect(event => {
          console.log('event', event)
        })
        .then(async () => {
          this.foxAddress = this.wallet.account
          this.foxChainId = this.wallet.chainId
          const balance = await this.wallet.getBalance()
          this.foxBalance = ethers.utils.formatUnits(balance)
          // this.wallet.disconnect()
        })
        .catch(() => {})
    },
    connectLedger() {
      this.wallet = new Ledger()
      this.wallet
        .connect()
        .then(async () => {
          this.foxAddress = this.wallet.account
          this.foxChainId = this.wallet.chainId
          const balance = await this.wallet.getBalance()
          this.foxBalance = ethers.utils.formatUnits(balance)

          for (let i = 1; i < 6; i++) {
            const address1 = await this.wallet.getAccount(
              this.wallet.PATHTYPEARRAY[0].type,
              i
            )
            this.ledgerAddress.push(address1)
          }
          // this.wallet.setAccount(this.ledgerAddress[0].address)
          // this.foxAddress = this.wallet.account
          // const balance2 = await this.wallet.getBalance()
          // this.foxBalance = ethers.utils.formatUnits(balance2)
        })
        .catch(err => {
          console.log('connectLedger', err)
        })
    },
    connectTrezor() {
      this.wallet = new Trezor()
      this.wallet
        .connect()
        .then(async () => {
          this.foxAddress = this.wallet.account
          this.foxChainId = this.wallet.chainId
          const balance = await this.wallet.getBalance()
          this.foxBalance = ethers.utils.formatUnits(balance)

          for (let i = 1; i < 6; i++) {
            const address1 = await this.wallet.getAccount(
              this.wallet.PATHTYPEARRAY[0].type,
              i
            )
            this.ledgerAddress.push(address1)
          }
          // this.wallet.setAccount(this.ledgerAddress[0].address)
          // this.foxAddress = this.wallet.account
          // const balance2 = await this.wallet.getBalance()
          // this.foxBalance = ethers.utils.formatUnits(balance2)
        })
        .catch(err => {
          console.log('connectTrezor', err)
        })
    },
    getQuote() {
      console.log('process.env.VUE_APP_0X', process.env.VUE_APP_0X)
      http
        .quote({
          buyToken: 'ETH',
          // sellToken: '0xff795577d9ac8bd7d90ee22b6c1703490b6512fd',
          sellToken: '0x4f96fe3b7a6cf9725f59d353f723c1bdb64ca6aa',
          sellAmount: ethers.utils.parseUnits('5', 18).toString()
        })
        .then(async data => {
          console.log('data', data)
          // const provider = new ethers.providers.InfuraProvider(
          //   'kovan',
          //   process.env.VUE_APP_INFURA_ID
          // )
          // const contract = new ethers.Contract(
          //   '0x4f96fe3b7a6cf9725f59d353f723c1bdb64ca6aa',
          //   CommonERC20,
          //   provider
          // )
          // const allow = await contract.allowance(
          //   this.foxAddress,
          //   data.allowanceTarget
          // )
          // console.log('allow', allow)
          const allow = await this.wallet.getAllowance([
            {
              ERC20: '0x4f96fe3b7a6cf9725f59d353f723c1bdb64ca6aa',
              spender: data.allowanceTarget
            }
          ])

          console.log(
            'allow',
            ethers.utils.formatUnits(
              allow['0x4f96fe3b7a6cf9725f59d353f723c1bdb64ca6aa']
            )
          )
          let approveRes
          try {
            approveRes = await this.wallet.approve(
              '0x4f96fe3b7a6cf9725f59d353f723c1bdb64ca6aa',
              data.allowanceTarget,
              data.sellAmount
            )
          } catch (err) {
            console.log('err', err, '////\n', err.message, '////\n', err.code)
          }
          console.log('approveHash', approveRes)
          this.wallet.getTx(approveRes.hash).then(getTx => {
            console.log('getTx 1', getTx)
          })
          const txState = await this.wallet.waitForTx(approveRes.hash)
          console.log('txState', txState)
          const tx = {
            from: this.foxAddress,
            to: data.to,
            gasPrice: '0x' + new BN(data.gasPrice).toString(16),
            // gasLimit: '0x' + new BN(data.estimatedGas).toString(16),
            gas: '0x' + new BN(data.gas).times('1.3').toString(16),
            data: data.data,
            value: '0x' + new BN(data.value).toString(16)
          }
          console.log('tx', tx)
          let hash
          try {
            hash = await this.wallet.sendTx(tx)
          } catch (eer) {
            console.log('eer', eer)
          }
          console.log('hash', hash)
          const sendTxState = await this.wallet.waitForTx(hash)
          console.log('sendTxState', sendTxState)
        })
        .catch(adfasdf => {
          console.log('adfasdf', adfasdf)
        })
    },
    async getBalanceBySelf() {
      const token = await http.tokens()
      console.log('token', token)
      const tokenAddress = []
      for (let item of token.records) {
        tokenAddress.push(item.address)
      }
      const res = await this.wallet.getBalance(tokenAddress)
      console.log('res', res)
      const list = []
      for (let item of token.records) {
        if (res[item.address] === null) {
          continue
        }
        const content = {
          symbol: item.symbol,
          balance: ethers.utils.formatUnits(res[item.address], item.decimals),
          address: item.address
        }
        list.push(content)
      }
      this.showList = list
    },
    disconnect() {
      this.wallet.disconnect().then(() => {
        console.log('disconnect')
      })
    },
    getDecimals() {
      const wallet = new MetaMask()
      wallet
        .getDecimals('0x4f96fe3b7a6cf9725f59d353f723c1bdb64ca6aa')
        .then(data => {
          console.log('getDecimals', data)
        })
    },
    async getExchangeData() {
      const res = await this.wallet.getBalance([
        '0x64C69807efaD634cC3b2f46E3140be43c1Ed8aE0',
        '0xD4075D8694B90Aa96795c5b24b49aaC1848f8AB2'
      ])
      console.log('res', res)
      this.npxsBalance = ethers.utils.formatUnits(
        res['0x64C69807efaD634cC3b2f46E3140be43c1Ed8aE0'],
        18
      )
      this.xsBalance = ethers.utils.formatUnits(
        res['0xD4075D8694B90Aa96795c5b24b49aaC1848f8AB2'],
        18
      )
      this.npxsRate = await this.wallet.getSwapRate()
      console.log('this.npxsRate', typeof this.npxsRate, this.npxsRate)
    },
    async exchangeNPXS() {
      // const res = await this.wallet.approve(
      //   '0x64C69807efaD634cC3b2f46E3140be43c1Ed8aE0',
      //   '0x32Cac282752d86d260a88aeA596830CdBf12d2D1',
      //   ethers.utils.parseUnits('100', 18).toString()
      // )
      // const tx = await this.wallet.waitForTx(res)
      // console.log('tx', tx)
      // const res2 = await this.wallet.swap(
      //   ethers.utils.parseUnits('100', 18).toString()
      // )
      // const tx2 = await this.wallet.waitForTx(res2)
      // console.log('tx2', tx2)

      // -----------------------------------------------------------------

      const res = await this.wallet.approve(
        '0x64C69807efaD634cC3b2f46E3140be43c1Ed8aE0',
        '0x32Cac282752d86d260a88aeA596830CdBf12d2D1',
        ethers.utils.parseUnits('100', 18).toString()
      )
      console.log('res', res)

      const approveTx = await this.wallet.waitForTx(res)
      console.log('approveTx', approveTx)

      const allow = await this.wallet.getAllowance([
        {
          ERC20: '0x64C69807efaD634cC3b2f46E3140be43c1Ed8aE0',
          spender: '0x32Cac282752d86d260a88aeA596830CdBf12d2D1'
        }
      ])

      console.log('allow', allow)

      const gasPrice = await this.wallet.getGasPrice()

      console.log('gasPrice', gasPrice.toString())

      const nonce = await this.wallet.getNonce()

      console.log('nonce', nonce)

      const txData = this.wallet.getSwapData(
        ethers.utils.parseUnits('100', 18).toString()
      )

      // // 简易兑换
      // const txData = this.wallet.getSimpleSwapData(
      //   ethers.utils.parseUnits('100', 18).toString()
      // )
      //
      console.log('txData', txData)

      const value = ethers.utils.parseEther('0')

      console.log('value', value)

      const tx = {
        from: this.foxAddress,
        value: value.toHexString(),
        to: '0x32Cac282752d86d260a88aeA596830CdBf12d2D1', // swap
        // to: '0x64C69807efaD634cC3b2f46E3140be43c1Ed8aE0', //npxs 简易兑换
        gasPrice: gasPrice.toHexString(),
        data: txData,
        nonce: String(nonce)
      }

      // gas 76631
      const gas = await this.wallet.estimateGas(tx)

      console.log('gas', gas.toString())

      const sendtx = {
        ...tx,
        gas: gas.toHexString()
      }
      console.log('sendtx', sendtx)

      const hash = await this.wallet.sendTx(sendtx)
      console.log('hash', hash)

      const sentTxState = await this.wallet.waitForTx(hash)
      console.log('sentTxState', sentTxState)
    }
  },
  mounted() {
    console.log('NODE_ENV', process.env.NODE_ENV)
    // const newBN = BN.clone({ EXPONENTIAL_AT: 100 })
    // console.log('fff', new newBN('0x' + 'f'.repeat(64)).toString())
  }
}
</script>

<style scoped>
.line {
  width: 100%;
  height: 1px;
  background-color: #ccc;
}
button + button {
  margin-left: 10px;
}
</style>
